import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { CardCode } from '@shared-models';

import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';
import { AppState } from 'src/app/state/app.state';
import { selectCompaniesList } from 'src/app/state/selectors/user-companies.selectors';

@Injectable({
  providedIn: 'root',
})
export class FormatInvoiceNumberService {
  private store = inject(Store<AppState>);
  private cookieAuthService = inject(CookieAuthService);

  private extractParts(
    invoiceNumber: string,
    voucher: number,
  ): { prefix: string; consecutive: string } | null {
    if (!invoiceNumber || !voucher) return null;

    const companyId =
      this.cookieAuthService.getCompanyObject?.Id_company?.toString();
    if (!companyId) return null;

    let prefix = '';

    this.store
      .select(selectCompaniesList)
      .subscribe((companies) => {
        const company = companies.find(
          (c) => c.Id_company.toString() === companyId,
        );
        if (company) {
          const prefixData = company.prefixes.find(
            (p) => p.voucher === voucher,
          );
          if (prefixData?.prefix) {
            prefix = prefixData.prefix;
          }
        }
      })
      .unsubscribe();

    if (!prefix) return null;

    const consecutive = invoiceNumber.replace(prefix, '');
    return { prefix, consecutive };
  }

  formatElectronicNumber(invoiceNumber: string, voucher: number): string {
    if (!invoiceNumber || !voucher) return invoiceNumber;

    try {
      const parts = this.extractParts(invoiceNumber, voucher);
      if (!parts) return invoiceNumber;

      return `${parts.prefix}${parts.consecutive}`;
    } catch {
      return invoiceNumber;
    }
  }

  getFormattedCardCode(
    invoiceNumber: string,
    voucher: number,
  ): Pick<CardCode, 'value' | 'boldPrefix'> {
    if (!invoiceNumber || !voucher) return { value: invoiceNumber };

    try {
      const parts = this.extractParts(invoiceNumber, voucher);
      if (!parts) return { value: invoiceNumber };

      return { value: parts.consecutive, boldPrefix: parts.prefix };
    } catch {
      return { value: invoiceNumber };
    }
  }
}
